<script lang="ts">
	import type { Content } from '$lib/services/content';
	import { locale } from '$lib/i18n';

	export let content: Content;
</script>

<div
	class="article bg-white max-w-[30rem] xl:min-w-[25rem] px-[2.5rem] py-[2rem] rounded-xl"
	style="box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.03);"
>
	<a href="/content/{content.id}/{content.slug}">
		<div class="min-h-[3.5rem]">
			{#if content?.showClient && content?.client}
				<div class="grid grid-cols-2 gap-4 justify-center mb-[2rem]">
					<div class="flex items-center justify-center">
						<img
							class="max-h-[2rem]"
							src={content.brand.logoUrl}
							title={content.brand.name}
							alt="{content.brand.name} logo"
						/>
					</div>
					<div class="flex items-center justify-center">
						<img
							class="max-h-[2rem] pt-1"
							src={content?.client?.logoUrl}
							alt="{content?.client?.name ?? ''} logo"
						/>
					</div>
				</div>
			{:else if content.brand.name !== 'Unknown'}
				<div class="flex justify-between flex-row mb-[2rem]">
					<img
						class="max-h-[2rem]"
						src={content.brand.logoUrl}
						title={content.brand.name}
						alt="{content.brand.name} logo"
					/>
				</div>
			{/if}
		</div>

		<div class="min-h-[16rem]">
			<img
				src={content.previewUrl}
				class="max-h-[14rem] max-w-[100%] mb-[2rem] mx-auto rounded-xl"
				style="box-shadow: 0px 0px 40px 10px rgba(0, 0, 0, 0.12);"
				alt="thumbnail of the content"
			/>
		</div>
		<h2
			class="text-left break-word min-h-[3.5rem] font-[500] -tracking-[0.07rem] text-[1.45rem] text-left mb-[.5rem] leading-[1.2] ml-[-0.1rem]"
		>
			{content.title}
		</h2>
		<div
			class="text-left text-[.8rem] font[400] h-[4.5rem] block leading-[1.4] xs:w-[400px] lg:w-full"
		>
			<div class="line-clamp-3">
				{@html content.synopsisText}
			</div>
		</div>
	</a>
	<div class="flex flex-wrap gap-2 max-w-[350px]">
		<span
			class="tag text-[.7rem] font-[400] mr-1 px-[.5rem] py-[.3rem] leading-[1] bg-dark-green text-[#ffffff] rounded-xl"
		>
			{content?.type?.translations?.name?.[$locale] || content?.type?.name || '-'}
		</span>
		{#each content?.categories as tag, index}
			<span
				class="tag text-[.7rem] font-[400] mr-1 px-[.5rem] py-[.3rem] leading-[1] bg-dark-green text-[#ffffff] rounded-xl"
			>
				{tag?.translations?.[$locale] || tag?.name || '-'}
			</span>
		{/each}
	</div>
</div>
